import React from "react";
import { getIFrameUrl } from "../../utils";

const RenaultOrBank11FinancingCalculator = ({
  vehicleDetails,
  financialCalculatorSettings,
}) => {
  return (
    <div className="bg-white">
      <iframe
        name={`${financialCalculatorSettings?.calculator?.toLowerCase()}Calculator`}
        id={`${financialCalculatorSettings?.calculator?.toLowerCase()}Calculator`}
        title={`${financialCalculatorSettings?.calculator?.toLowerCase()}Calculator`}
        src={getIFrameUrl(vehicleDetails, financialCalculatorSettings)}
      ></iframe>
    </div>
  );
};

export default RenaultOrBank11FinancingCalculator;
